import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { initiateStudioLoginReset, loginStudioAction } from "../../store/auth/authActions";
import {
    selectStudioToken,
    selectIsStudioLoginFailed,
    selectStudioLoginResetResult,
    selectStudioLoginResetResultError
} from "../../store/auth/authSelector";
import { useTranslation } from "react-i18next";
import { i18_TRANSLATION } from "../../i18nReferences";
import i18n from "../../i18n";
import LoginStudioView from "./LoginStudioView";
import LoginContainer from "./LoginContainer";

/**
 * Container component for studio login
 * Manages Redux state for studio login
 */
const LoginStudioContainer = () => {
    const dispatch = useDispatch();
    const isStudioLoginFailed = useSelector(state => selectIsStudioLoginFailed(state));
    const isStudioLoggedIn = useSelector(state => selectStudioToken(state));
    const studioLoginResetResult = useSelector(state => selectStudioLoginResetResult(state));
    const studioLoginResetResultError = useSelector(state => selectStudioLoginResetResultError(state));
    const { t } = useTranslation([i18_TRANSLATION]);

    const loginHandler = data => dispatch(loginStudioAction(data));
    const handleReset = (studioName) => dispatch(initiateStudioLoginReset({ studioName, locale: i18n.language }));

    return (
        <LoginContainer maxWidth="xl">
            <LoginStudioView
                t={t}
                onSubmit={loginHandler}
                isLoginFailed={isStudioLoginFailed}
                isLoggedIn={!!isStudioLoggedIn}
                successText={t('LOGIN_STUDIO.SUCCESS_TEXT')}
                loginFailedText={t('LOGIN_STUDIO.FAILED_TEXT')}
                nameText={t('LOGIN.STUDIO_NAME')}
                onClickReset={handleReset}
                loginResetResult={studioLoginResetResult}
                loginResetError={studioLoginResetResultError}
            />
        </LoginContainer>
    );
};

export default LoginStudioContainer;